import { priceStore } from "../zustand/priceStore";

export interface FxCalculatorState {
	ccy1: string;
	ccy2: string;
}

const CHF = "CHF";
const SEK = "SEK";
const NOK = "NOK";
const DKK = "DKK";

function useFxRates(props: FxCalculatorState) {
	const values = priceStore((state) => state.prices);

	const calculateFxRate = (ccy1: string, ccy2: string) => {
		//find direct rate
		const rate = findRate(`${ccy1}/${ccy2}`);
		if (rate != null) {
			return rate;
		} else {
			// calculate cross rates
			let baseRateValue = findRate(`USD/${ccy1}`);
			if (baseRateValue === null) {
				baseRateValue = 0;
			}

			let quoteRateObject = findRate(`USD/${ccy2}`);
			if (quoteRateObject === null) {
				quoteRateObject = 0;
			}

			const crossRate = (1 / baseRateValue) * quoteRateObject;
			return crossRate;
		}
	};

	const findRate = (symbol: string): number | null => {
		let rateObj = values.find((rate) => rate.ccyPair === symbol);
		if (rateObj == null) {
			if(symbol === 'USD/USD')
				return 1;
			else{
				const eurBasedCcy1 = isEurBasedCcy(symbol);
				if (eurBasedCcy1 !== null) {
					return findEurBasedRate(symbol, eurBasedCcy1);
				} else {
					rateObj = values.find(
						(rate) =>
							rate.ccyPair === `${symbol.split("/")[1]}/${symbol.split("/")[0]}`
					);
					return rateObj ? 1 / rateObj.midRate : null;
				}
			}
		} else {
			return rateObj.midRate;
		}
	};

	const isEurBasedCcy = (symbol: string) => {
		let ccy1 = null;
		if (symbol.includes(CHF)) {
			ccy1 = CHF;
		} else if (symbol.includes(NOK)) {
			ccy1 = NOK;
		} else if (symbol.includes(SEK)) {
			ccy1 = SEK;
		} else if (symbol.includes(DKK)) {
			ccy1 = DKK;
		}

		return ccy1;
	};

	const findEurBasedRate = (symbol: string, ccy1: string) => {
		const eurchfRate = findRate(`EUR/${ccy1}`);
		const eurusdRate = findRate(`EUR/USD`);
		if (eurusdRate != null && eurchfRate != null) {
			const ccy2 =
				symbol.split("/")[0] === ccy1
					? symbol.split("/")[1]
					: symbol.split("/")[0];
			let baseRateValue = (1 / eurusdRate) * eurchfRate;
			if (symbol === `USD/${ccy1}`) {
				return baseRateValue;
			} else if (symbol === `${ccy1}/USD`) {
				return 1 / baseRateValue;
			} else {
				let quoteRateObject = findRate(`USD/${ccy2}`);
				if (quoteRateObject === null) {
					quoteRateObject = 0;
				}
				if (symbol.split("/")[0] === ccy1) {
					return (1 / baseRateValue) * quoteRateObject;
				} else {
					return (1 / quoteRateObject) * baseRateValue;
				}
			}
		} else {
			return 1;
		}
	};


	return { calculateFxRate };
}

export default useFxRates;

/*
	const findChfRate = (symbol: string) => {
		const eurchfRate = findRate(`EUR/CHF`);
		const eurusdRate = findRate(`EUR/USD`);
		if (eurusdRate != null && eurchfRate != null) {
			const ccy2 =
				symbol.split("/")[0] === "CHF"
					? symbol.split("/")[1]
					: symbol.split("/")[0];
			let baseRateValue = (1 / eurusdRate) * eurchfRate;
			if (symbol === "USD/CHF") {
				return baseRateValue;
			} else if (symbol === "CHF/USD") {
				return 1 / baseRateValue;
			} else {
				let quoteRateObject = findRate(`USD/${ccy2}`);
				if (quoteRateObject === null) {
					quoteRateObject = 0;
				}
				if (symbol.split("/")[0] === CHF) {
					return (1 / baseRateValue) * quoteRateObject;
				} else {
					return (1 / quoteRateObject) * baseRateValue;
				}
			}
		} else {
			return 1;
		}
	};

*/
